import React, { useState } from "react";
import Label from "lib/Label";
import "./index.scss";
import { Row, Col, Image, Container } from "react-bootstrap";
import CalenderIcon from "../../../src/assets/images/Icon awesome-calendar-alt.png";
import GreenTick from "../../../src/assets/images/Group 28410@2x.png";
import GreyTick from "../../../src/assets/images/Group 39041@2x.png";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { sendVKYCReminderToUser } from "api/dashboardDetail";
import Toast from "components/ToastComponent";
import { setFailedToSendVKYCREminderToUser, setUploadedDoc } from "redux/vkycReducer";
import PlaceHolderLoader from "components/PlaceHolderLoader";


const CardQueue = (props) => {
  const {
    selectedData,
    allData,
    title,
    form_field_items,
    input_fields,
    custom_styles,
    doesAnySubWorkflowHasVkyc,
    trigger,
    video_kyc_doc
  } = props;

  const dispatch = useDispatch();
  const vkyCQueue = useSelector((state) => state?.vkycReducer?.vkyCQueue);
  const vkycResponseOfAllSubWorkFlows = useSelector(
    (state) => state.vkycReducer.vkycResponseOfAllSubWorkFlows
  );
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  ).organisationInfo?._id;

  // const vkycStatus = useSelector((state) => state.vkycReducer.vkycStatus);
  const vkycActiveStep = useSelector(
    (state) => state.vkycReducer.vkycActiveStep
  );

  const failedToSendVKYCREminderToUser = useSelector(
    (state) => state.vkycReducer.failedToSendVKYCREminderToUser
  );

  const successFullySentVKYCREminderToUser = useSelector(
    (state) => state.vkycReducer.successFullySentVKYCREminderToUser
  );

  const workFlowInfo = useSelector(
    (state) => state.dashboardDetailReducer.workFlowInfo
  );

  const sentToUser = useSelector((state) => state.vkycReducer.sentToUser);
  useState(() => {
    dispatch(setUploadedDoc(video_kyc_doc))
  },[])

  const decideTheImageToDisplat = (status, index) => {
    if (status === "In draft") {
      return (
        <Image
          style={{
            width: "25px",
            height: "25px",
          }}
          src={CalenderIcon}
          alt="calender"
        />
      );
    } else if (
      vkyCQueue?.[index] &&
      vkycResponseOfAllSubWorkFlows?.[
        vkycResponseOfAllSubWorkFlows.findIndex(
          (items) => items?.customer_id === vkyCQueue?.[index]?.customer_id
        )
      ]
    ) {
      return (
        <Image
          style={{
            width: "25px",
            height: "25px",
          }}
          src={GreenTick}
          alt="calender"
        />
      );
    } else {
      return (
        <Image
          style={{
            width: "25px",
            height: "25px",
          }}
          src={GreyTick}
          alt="calender"
        />
      );
    }
  };

  const userSubworkFlowInfoLoading = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfoLoading
  );
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  let current_role;
  if(loggedInUserInfo?.modules) {
    current_role = loggedInUserInfo?.modules.find((item) => item?.module_name == "DKYC_Dashboard")
  }
  current_role = current_role ? current_role : { read : true, edit: false}

  const getStatus = (status, index) => {
    if (
      vkycResponseOfAllSubWorkFlows?.[
        vkycResponseOfAllSubWorkFlows.findIndex(
          (items) => items?.reference_id === vkyCQueue?.[index]?.reference_id
        )
      ] &&
      vkyCQueue?.[index] && vkycResponseOfAllSubWorkFlows?.[index]?.dkyc_request?.current_status == "Awaiting Approval" 
    ) {
      return (
        <span className={`p-2 fs-13px rounded-1 ${"bg-verification-completed"}`}>
          {"Verification Completed" || "NA"}
        </span>
      );
    } else if (
      vkyCQueue?.[index] &&
      !vkycResponseOfAllSubWorkFlows[
        vkycResponseOfAllSubWorkFlows.findIndex(
          (items) => items?.reference_id === vkyCQueue?.[index]?.reference_id
        )
      ]
    ) {
      return (
        <span className={`p-2 fs-13px rounded-1 ${"bg-awaiting-approval"}`}>
          {"Invitation sent successfully"}
        </span>
      );
    } else {
      return (
        <span className={`p-2 fs-13px rounded-1 ${"bg-awaiting-approval"}`}>
          {"Awaiting Completion"}
        </span>
      );
    }
  };

  const handleSendReminder = (data, index) => {
    const body = {
      reference_id: data?.reference_id,
      sub_workflow_id: workFlowInfo.source_data?.subworkflows?.[index]?._id
        ? workFlowInfo.source_data.subworkflows[index]?._id
        : selectedData?._id,
      userName: workFlowInfo.source_data?.subworkflows?.[index]?.full_name
        ? workFlowInfo.source_data.subworkflows[index]?.full_name
        : selectedData?.full_name,
      email_id: workFlowInfo.source_data?.subworkflows?.[index]?.email
        ? workFlowInfo.source_data?.subworkflows?.[index]?.email
        : selectedData?.email,
      org_id: organisation_id,
      link: data.customer_url,
      org_name: "Kotak",
      trigger: trigger,
    };

    if (
      !body?.link ||
      !body?.email_id ||
      !body?.reference_id ||
      !body?.sub_workflow_id ||
      !body?.org_id ||
      !body?.org_name
    ) {
      //  if(true){
      console.error("Missing params to send reminder");
      dispatch(setFailedToSendVKYCREminderToUser());
    }
    dispatch(sendVKYCReminderToUser(body));
  };

  return (
    <>
      {successFullySentVKYCREminderToUser && (
        <Toast
          message={`VKYC reminder sent to ${sentToUser} sucessfully!`}
          type="success"
          autoClose={3000}
        />
      )}

      {failedToSendVKYCREminderToUser && (
        <Toast
          message={`Failed to send reminder to ${sentToUser}! Please try again later`}
          type="error"
          autoClose={3000}
        />
      )}
      {userSubworkFlowInfoLoading && <PlaceHolderLoader />}
      {vkyCQueue &&
        vkyCQueue.map((item, index) => {
          if(item != null && item != undefined) {
            return (
              <>
              {item && (
                <div className={custom_styles} key={index}>
                <Row className="border-theme-grey rounded-3 gy-3 gy-md-0">
                <Col  xs={12} md={{order:0, span:6}} lg={{order:0,span:4}}>
                  <div className="d-inline-flex">
                    <Label
                      label={
                        workFlowInfo?.source_data?.subworkflows?.[index]
                        ?.full_name
                      }
                      className="fw-bold"
                    />
                    <span className={`text-primary mt-2`}>
                      {item?.module}
                    </span>
                  </div>
                  {vkycResponseOfAllSubWorkFlows[
                            vkycResponseOfAllSubWorkFlows.findIndex(
                              (items) => items?.customer_id === item?.customer_id
                            )
                          ]?.dkyc_request?.scheduler_details?.scheduled_date && (
                            <Row className="gy-md-1 gy-lg-0">
                              <Col className="d-flex align-items-center px-1" xs={6} md={6} lg={4}>
                              <div className="me-2">
                              <img alt="calender " src={CalenderIcon} />{" "}
                              </div>
                                <p className="m-0 fs-12px mt-1">{moment(
                                  vkycResponseOfAllSubWorkFlows[index]?.dkyc_request
                                    ?.scheduler_details?.scheduled_date
                                ).format("DD MMM YYYY")}</p>
                                </Col>
                              <Col className="d-flex align-items-center px-1 px-md-0 p-md-1 ps-lg-0"  xs={6} md={6} lg={4}>
  
                              <div className="me-2 d-flex align-items-center">
                              {" "}
                                <i
                                  class="fa fa-clock-o"
                                  style={{ color: "#8097ac"}}
                                ></i>
                              </div>
                                <p className="m-0 fs-12px mt-1">{
                                    vkycResponseOfAllSubWorkFlows[
                                      vkycResponseOfAllSubWorkFlows.findIndex(
                                        (items) =>
                                          items?.customer_id === item?.customer_id
                                      )
                                    ]?.dkyc_request?.scheduler_details
                                      ?.slot_interval
                                }</p>
                              </Col>
                            </Row>
                          )}
              
                </Col>
                <Col xs={12} md={{order:2, span:6}} lg={{order:1,span:4}}>
                    <div className="d-flex align-items-center justify-content-md-start justify-content-center justify-content-lg-center h-100">
                    {item?.status === "failed" ? (
                            <div>
                              <span
                                className={` ${"bg-processing-failed"}`}
                              >
                                {item.status}-{item.message}
                              </span>
                            </div>
                          ) : (
                            <span className={``}>
                              {getStatus(item, index)}
                            </span>
                          )}
                    </div>
                </Col>
                <Col xs={12} md={{order:1,span:6}} lg={{order:2,span:4}}>
  
                {item?.executive_url &&
                          vkycResponseOfAllSubWorkFlows[
                            vkycResponseOfAllSubWorkFlows.findIndex(
                              (items) => items?.customer_id === item?.customer_id
                            )
                          ]?.dkyc_request?.current_status !==
                            "Awaiting Approval" ? (
                              <Container>
                                <div className="row gy-3 gy-lg-0">
                              <div className="col-lg-6 col-md-6 col-sm-12 button-card text-center">
                              <button
                                  onClick={() => handleSendReminder(item, index)}
                                  // disabled={true}
                                  className="send-button btn text-blue-theme fw-bold bg-theme-grey-light-four"
                                >
                                  Send Reminder
                                </button>
                              </div>
                              {item?.module === "Assisted" && current_role?.edit && (
                                <div
                                  disabled={
                                    !vkycResponseOfAllSubWorkFlows[
                                      vkycResponseOfAllSubWorkFlows.findIndex(
                                        (items) =>
                                          items?.customer_id === item?.customer_id
                                      )
                                    ]?.dkyc_request?.scheduler_details
                                  }
                                  onClick={() => {
                                    window.open(item?.executive_url, "_blank");
                                  }}
                                  className="col-lg-6 col-md-6 col-sm-12 button-card text-center"
                                >
                                <button className="call-button btn bg-primary-theme text-white fw-bold px-3 px-lg-4">Call</button>
                                </div>
                              )}
                            </div>
                              </Container>
                          
                          ) : (
                            <div
                            className="d-flex align-items-center justify-content-center justify-content-md-end h-100"
                            >
                              {decideTheImageToDisplat(item?.message, index)}
                            </div>
                          )}
  
                </Col>
              </Row>
              </div>
              )}
              </>
          )
          } else return <></>
        })}
    </>
  );
};

export default CardQueue;
